import React, { createContext, useContext, useState } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

const ToastProvider = ({ children }) => {
  const [toastMessage, setToastMessage] = useState(null);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const showToast = (message, type) => {
    setToastMessage({ message, type });
    if (type === "success") {
      setSeverity(type);
      setTitle("Success");
      setMessage(message);
      setOpen(true);
    } else {
        setSeverity(type);
        setTitle("Warning");
        setMessage(message);
        setOpen(true);
    }
  };

  const hideToast = () => {
    setOpen(false);
  };

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      {toastMessage && (
        <div className="p-4">
          <Stack sx={{ width: "300px" }} spacing={2}>
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={open}
              autoHideDuration={6000}
              onClose={hideToast}
              TransitionComponent={Slide}
            >
              <Alert
                onClose={hideToast}
                severity={severity}
                sx={{ width: "300px" }}
              >
                <AlertTitle >{title}</AlertTitle>
                {message}
              </Alert>
            </Snackbar>
          </Stack>
        </div>
      )}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
